import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useUserJobProspectsState() {
  return useAppState();
}

export function useUserJobProspectsActions() {
  const dispatch = useAppDispatch();

  function initializeState(userId) {
    dispatch((appState) => ({
      ...appState,
      userId,
      loading: true,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response, selectedJobProspectIds: [] }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function openDeleteJobProspectModal(jobProspect) {
    dispatch((appState) => ({
      ...appState,
      deleteJobProspectModalIsOpen: true,
      deleteJobProspectForm: jobProspect,
    }));
  }

  function closeDeleteJobProspectModal() {
    dispatch((appState) => ({
      ...appState,
      deleteJobProspectModalIsOpen: false,
      deleteJobProspectForm: null,
    }));
  }

  function openJobClosedWarningModal(jobProspect) {
    dispatch((appState) => ({
      ...appState,
      jobClosedWarningModalIsOpen: true,
      jobClosedWarningForm: jobProspect,
    }));
  }

  function closeJobClosedWarningModal() {
    dispatch((appState) => ({
      ...appState,
      jobClosedWarningModalIsOpen: false,
      jobClosedWarningForm: null,
    }));
  }

  function toggleJobProspectSelection(id) {
    dispatch((appState) => {
      const current = appState.selectedJobProspectIds || [];
      const updated = current.includes(id)
        ? current.filter(selectedId => selectedId !== id)
        : [...current, id];
      return { ...appState, selectedJobProspectIds: updated };
    });
  }

  function selectAllJobProspects(ids) {
    dispatch((appState) => ({
      ...appState,
      selectedJobProspectIds: ids,
    }));
  }

  function clearSelection() {
    dispatch((appState) => ({
      ...appState,
      selectedJobProspectIds: [],
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    clearFeedback,
    openDeleteJobProspectModal,
    closeDeleteJobProspectModal,
    openJobClosedWarningModal,
    closeJobClosedWarningModal,
    toggleJobProspectSelection,
    selectAllJobProspects,
    clearSelection,
  };
}
